import {HttpClient} from '@angular/common/http';
import {App} from '@capacitor/app';
import {Browser} from '@capacitor/browser';
import {inject, Injectable} from '@angular/core';
import {AlertController, Platform} from '@ionic/angular';
import {environment} from '../../environments/environment';
import {UtilityService} from './utility.service';
import {UTILITY} from '../components/utility/utility.component';
import {retry} from 'rxjs';

interface Maintenance {
    data: {
        version: string;
        enabled: boolean;
        title?: string;
        message?: string;
        button?: string;
    };
}

interface AppUpdate {
    data: {
        version: string;
        enabled: boolean;
        linkAppStore?: string;
        linkPlayStore?: string;
        title?: string;
        message?: string;
        button?: string;
    };
}

@Injectable({
    providedIn: 'root'
})

export class UpdateService {
    private readonly http: HttpClient = inject(HttpClient);
    private readonly alertCtrl: AlertController = inject(AlertController);
    private readonly platform: Platform = inject(Platform);
    private readonly utilityService: UtilityService = inject(UtilityService);
    urlApi = environment.urlApi;
    updateLink = this.urlApi + environment.UPDATE_APP_GET;
    maintenanceLink = this.urlApi + environment.MAINTENANCE_GET;

    constructor() {
    }

    async checkForUpdate(): Promise<void> {
        this.http.get<Maintenance>(this.maintenanceLink).pipe(
            retry({count: 5, delay: 1000})
        ).subscribe({
            next: (maintenance) => {
                if (maintenance.data.enabled) {
                    this.presentAlert(
                        maintenance.data.title,
                        maintenance.data.message,
                        null,
                        null,
                        null,
                        false
                    );
                } else {
                    this.http.get<AppUpdate>(this.updateLink).pipe(
                        retry({count: 5, delay: 1000})
                    ).subscribe({
                        next: async (appUpdate) => {
                            if (appUpdate.data.enabled) {
                                const versionNumber = (await App.getInfo()).version;
                                const [maj, min, pat] = versionNumber.split('.').map(Number);
                                const [sMaj, sMin, sPat] = appUpdate.data.version.split('.').map(Number);

                                if (sMaj > maj) {
                                    await this.presentAlert(
                                        appUpdate.data.title,
                                        appUpdate.data.message,
                                        appUpdate.data.button,
                                        appUpdate.data.linkAppStore,
                                        appUpdate.data.linkPlayStore,
                                        false
                                    );
                                } else if (sMin > min || sPat > pat) {
                                    await this.presentAlert(
                                        appUpdate.data.title,
                                        appUpdate.data.message,
                                        appUpdate.data.button,
                                        appUpdate.data.linkAppStore,
                                        appUpdate.data.linkPlayStore,
                                        true
                                    );
                                }
                            }
                        },
                        error: (err) => {
                            this.utilityService.presentAlertErrorGeneric(101, err);
                        }
                    });
                }
            },
            error: (err) => {
                this.utilityService.presentAlertErrorGeneric(102, err);
            }
        });
    }

    async openAppstoreEntry(linkStore: string) {
        await Browser.open({url: linkStore});
    }

    async presentAlert(header: string, message: string, buttonText: string, linkAppStore: string, linkPlayStore: string,
                       allowClose: boolean) {
        const buttons: any = [];
        if (allowClose) {
            buttons.push({
                text: 'Chiudi',
                role: 'cancel'
            });
        }

        if (UTILITY.checkText(buttonText)) {
            buttons.push({
                text: buttonText,
                handler: () => {
                    if (this.platform.is('android')) {
                        this.openAppstoreEntry(linkPlayStore);
                    } else {
                        this.openAppstoreEntry(linkAppStore);
                    }
                }
            });
        }


        const alert = await this.alertCtrl.create({
            header,
            message,
            buttons,
            backdropDismiss: allowClose
        });
        await alert.present();
    }

}
